export const SET_HAS_REFERENCE_DATA = 'SET_HAS_REFERENCE_DATA';

export const SetHasRefenceData = (value) => {
    return {
        type: SET_HAS_REFERENCE_DATA,
        payload: {
            value: value
        }
    }
}